module.exports = __webpack_public_path__ + "img/Number=96.5ce9f356.png";